import styled from 'styled-components';
import theme from '../../../../theme';

const Container = styled.div`
    width: calc(100% - 40px);
    max-width: 600px;
    min-height: calc(100vh - 80px);
    top: 0;
    padding: 10px 0;

    button {
        margin-top: auto;
    }
`;

const Content = styled.div`
    min-height: calc(100vh - 80px);   
    display: flex;
    flex-direction: column;
    background-color: ${theme.white};
    padding: 30px;
    border-radius: 30px;
    gap: 10px;
    
    h1 {
        font-size: 36px;
        font-weight: 700;
        color: ${theme.textDark};
    }

    h4 {
        font-size: 16px;
        font-weight: 400;
        color: ${theme.textDark};

        span {
            font-size: 24px;
            font-weight: 700;
        }
    }

    h6 {
        font-size: 14px;
        font-weight: 400;
        color: ${theme.textDark};
    }
`;

const BalanceContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: auto;

    span {
        margin-top: 20px;
        font-size: 13px;
        font-weight: 400;
        color: ${theme.textDark};
        margin-bottom: 10px;
    }
`;

const BalanceContent = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${theme.secondaryColor};
    border-radius: 8px;
    width: 100%;
`;

const BalanceExhibitor = styled.div`
    display: flex;
    align-items: center;
    padding: 10px;

    img {
        width: 24px;
        height: 24px;
    }

    div {
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        
        strong {
            font-size: 11px;
            font-weight: 700;
            color: ${theme.textDark};
        }

        small {
            font-size: 11px;
            font-weight: 400;
            color: ${theme.textDark};
        }
    }
`;


const BalanceAmount = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px 10px 10px;

    div {
        display: flex;
        flex-direction: column;
        text-align: center;

        span {
            font-size: 28px;
            font-weight: 900;
            color: ${theme.textDark};
        }

        small {
            font-size: 11px;
            font-weight: 400;
            color: ${theme.textDark};
        }
    }
`;

export { Container, Content, BalanceContainer, BalanceContent, BalanceExhibitor, BalanceAmount };